import React, { Fragment, useEffect, useMemo } from "react";
import { PageScrollIndicator } from "oolib";
import { useFormValidationContext } from "../../../../contexts/formValidationContext";
import { useHandleContentChange } from "../../../../utils/contributionFlowUtils";
import { __GetContentTypeConfigNew } from "../../../../utils/getters/gettersV2";
import { formValidationCheckV2 } from "../../../../utils/validation/formValidation";
import { getThisLayout } from "./configs";
// import { useFireOneAutosaveAtATime } from "./utils/useFireOneAutosaveAtATime";
import ReviewerNotes from "../ReviewerNotes";

export default function EditLayoutRenderer({
  tpl,
  autosave,
  isModerateMode,
  contentState: [content, setContent],
  // isAutoSaving: _isAutoSaving,
  // isAutoSaved,
  publishBtnTextAndOnClickAndDisabled,
  setHasPendingChanges,
  setActivePageIdx,
  activePageIdx,
  stepValidation,
  setStepValidation,
  H_PrimaryCTA,
  H_SaveStatus,
  H_CloseButton
}) {
  const { setFormValidation } = useFormValidationContext();


  const { Layout, blocksToValidate } = useMemo(() => getThisLayout({ tpl, content }), [tpl?.layout]);

  const templateIndex = __GetContentTypeConfigNew(tpl.kp_content_type)?.general
    ?.templateIndex;

  useEffect(() => {
    const { failedBlocks } = formValidationCheckV2({
      blocks: blocksToValidate,
      content,
    });
    setFormValidation((p) => ({ ...p, failedBlocks }));
  }, []);

  const { handleContentChange } = useHandleContentChange({ setHasPendingChanges });

  /**
   * not needed anymore since the autosave api now is using $set to make atomic updates
   * to specific fields, so even if multiple autosaves are triggered concurrently on 
   * different fields or even the same, we should be fine. As per claude, $set is atomic and
   * hence we should be fine.. but we will observe for a while.
   * ALSO ALSO earlier the write conflict issue in the api, that this hook was solving, was 
   * because of transactions maybe, and now the api has no transactions so..
   * 
   * if in case we are not fine, then this function will have to be looked at in detail,
   * because the current system is extremely detrimential cuz it overwrites the pending changes 
   * state if there are multiple, rather than queuing them.
   */
  // const { setPendingAutosaveContent, isAutoSaving } = useFireOneAutosaveAtATime(
  //   {
  //     autosave,
  //     isAutoSaved,
  //     _isAutoSaving,
  //     isModerateMode,
  //   }
  // );

  const handleOnChange = (block, value, options = {}) =>
    handleContentChange({
      block,
      value,
      setContent,
      setFormValidation,
      blocksToValidate,
      options,
      optimizeFieldUpdatesInMutation: true,
      mutate: ({ updateFields }) => {
        const contentType = content.meta.kp_content_type;
        const contentId = content._id
        // if (isAutoSaving.current) {
        //   setPendingAutosaveContent({updateFields, contentType, contentId});
        // } else {
        //   // console.log('autosave fired', {isAutoSaving: isAutoSaving.current})
          autosave({
            updateFields, contentType, contentId,
            ACTION: isModerateMode ? "MODERATE" : undefined,
          });
        // }
      },
    });

  return (
    <div className="OKE-Tpl">
      <Fragment>
        <PageScrollIndicator />
        {content.reviewerNotes?<ReviewerNotes notes={content.reviewerNotes} />:null} 
        <Layout
          {...{
            tpl,
            content,
            handleOnChange,
            showIndexbar: templateIndex?.enableOnContributeTpl,
            indexType: templateIndex?.type,
            publishBtnTextAndOnClickAndDisabled,

            setActivePageIdx,
            activePageIdx,
            stepValidation,
            setStepValidation,
            //header comps
            H_PrimaryCTA,
            H_SaveStatus,
            H_CloseButton
          }}
        />
      </Fragment>
    </div>
  );
}
